import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = '/rsvp';

class RSVPService {
  findGuest = async body => {
    try {
      const { firstName, lastName, rsvpKey } = body;
      const response = await axiosApiClient.get(
        `${BASE_URL}/guests/invitation/${rsvpKey}?&firstName=${firstName}&lastName=${lastName}`,
      );
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message } = response.data;
      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while finding guest');
    }
  };

  fetchRSVPDetails = async key => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/guest-portal/details/${key}`);
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message } = response.data;
      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching RSVP details');
    }
  };

  createGuestAnswers = async (id, body) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/guest-portal/answers/${id}`, body);
      if (response.status !== 201) {
        throw new Error();
      }

      const { data, message } = response.data;
      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating guest answers');
    }
  };
}
const rsvpService = new RSVPService();

export default rsvpService;
